import BatchProcessAnalysisResultModal from './batch-process-analysis-result-modal.vue'
export default BatchProcessAnalysisResultModal
